import { useState } from 'react'
import { Toggle, VerificationCodeInput } from '@/shared/ui'

export function VerificationCodePreview() {
  const [value, setValue] = useState('')
  return <VerificationCodeInput value={value} onChange={setValue} />
}

export function TogglePreview() {
  const [checked, setChecked] = useState(true)
  return <Toggle checked={checked} onChange={setChecked} />
}
